module.exports = __webpack_public_path__ + "img/double-arrow.6e48af57.svg";